export { default } from './useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/useMediaQuery/index.js
// module id = 607
// module chunks = 121